import { render, staticRenderFns } from "./XRayClickRegions.vue?vue&type=template&id=cea23d50"
import script from "./XRayClickRegions.vue?vue&type=script&lang=js"
export * from "./XRayClickRegions.vue?vue&type=script&lang=js"
import style0 from "./XRayClickRegions.vue?vue&type=style&index=0&id=cea23d50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports